// extracted by mini-css-extract-plugin
module.exports = {"goTo":"styles_goTo__1xKiY","text":"styles_text__3SXp6","input":"styles_input__3RYqk"};